import { demoUser, useAppSelector } from "@hypexone/uicore";

export const useWhatsappLink = () => {
  const { domainConfig, whatsappDetails } = useAppSelector(
    (state) => state.common
  );
  const { loggedIn } = useAppSelector((state) => state.auth);

  const demoUserWhatsappDetails =
    domainConfig?.suppportContacts?.find(
      (ct) => ct.contactType === "REGISTRATION_WHATSAPP_LINK"
    )?.details || null;

  const whatsappLink =
    demoUser() || !loggedIn ? demoUserWhatsappDetails : whatsappDetails;

  return { whatsappLink };
};
